import { createSelector } from "reselect";
import { getSelectedContextData } from "orion-components/Profiles/Selectors";

const getAttachments = (state, contextId) => getSelectedContextData(state)(contextId, "attachments");

const getUploadError = (state, contextId) => getSelectedContextData(state)(contextId, "uploadError");

const byDateDesc = (a, b) => {
	if (a.createdDate > b.createdDate) return -1;
	if (a.createdDate < b.createdDate) return 1;
	return 0;
};

const uploadErrorSelector = createSelector([getUploadError], uploadError => {
	return uploadError ?? "";
});

const imageAttachmentsSelector = createSelector([getAttachments], attachments => {
	const imageAttachments = attachments?.filter(attachment => attachment.mimeType.startsWith("image/")) || [];
	imageAttachments.sort(byDateDesc);
	return imageAttachments;
});

const videoAttachmentsSelector = createSelector([getAttachments], attachments => {
	const videoAttachments = attachments?.filter(attachment => attachment.mimeType.startsWith("video/")) || [];
	videoAttachments.sort(byDateDesc);
	return videoAttachments;
});

const otherAttachmentsSelector = createSelector([getAttachments], attachments => {
	const otherAttachments =
		attachments?.filter(
			attachment => !(attachment.mimeType.startsWith("image/") || attachment.mimeType.startsWith("video/"))
		) || [];
	otherAttachments.sort(byDateDesc);
	return otherAttachments;
});

export { imageAttachmentsSelector, videoAttachmentsSelector, otherAttachmentsSelector, uploadErrorSelector };
